import React, { useEffect, useState, createElement } from 'react';
import { CountdownTimer } from './components/CountdownTimer';
import { PurchasePopup } from './components/PurchasePopup';
import { ExitIntentPopup } from './components/ExitIntentPopup';
import { VideoIntroPopup } from './components/VideoIntroPopup';
import { ProductPreviewCarousel } from './components/ProductPreviewCarousel';
import { UrgencyModule } from './components/UrgencyModule';
import { CheckIcon, XIcon, ShieldIcon, DownloadIcon, UsersIcon, ClockIcon, StarIcon, ZapIcon, AwardIcon, ChevronDownIcon } from 'lucide-react';
const PURCHASE_URL = 'https://gf0puq-6f.myshopify.com/cart/52842799333600:1?channel=buy_button';
const MESES_ES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
function getTodayInSpanish() {
  const today = new Date();
  const day = today.getDate();
  const month = MESES_ES[today.getMonth()];
  return `${day} de ${month}`;
}
export function App() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const [todayLabel] = useState(getTodayInSpanish());
  // Meta Pixel injection
  useEffect(() => {
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '1486404246405720');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=1486404246405720&ev=PageView&noscript=1" />`;
    document.body.appendChild(noscript);
  }, []);
  const scrollToOffer = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const compraSection = document.getElementById('compra');
    if (compraSection) {
      compraSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <PurchasePopup data-id="element-1" />
      <ExitIntentPopup data-id="element-2" />

      {/* Top Urgency Bar — Premium Deep Navy & Gold */}
      <div className="w-full bg-gradient-to-r from-slate-950 via-slate-900 to-slate-950 text-white py-3 px-4 text-center sticky top-0 z-50 border-b border-yellow-500/50 shadow-[0_4px_25px_rgba(0,0,0,0.5)] relative overflow-hidden" data-id="element-3">
        <div className="absolute inset-0 bg-[linear-gradient(90deg,transparent_0%,rgba(234,179,8,0.05)_50%,transparent_100%)]" data-id="element-4"></div>
        <div className="max-w-7xl mx-auto relative z-10" data-id="element-5">
          <div className="flex flex-wrap items-center justify-center gap-2 text-xs md:text-sm" data-id="element-6">
            <span className="flex items-center gap-2" data-id="element-7">
              <span className="text-yellow-500 animate-pulse" data-id="element-8">⚖️</span>
              <span className="font-black text-transparent bg-clip-text bg-gradient-to-r from-yellow-200 via-yellow-400 to-yellow-200 uppercase tracking-widest drop-shadow-sm" data-id="element-9">
                Oferta exclusiva solo por hoy {todayLabel}
              </span>{' '}
              <span className="text-slate-400 font-medium hidden sm:inline" data-id="element-10">
                — Expira en:
              </span>{' '}
              <CountdownTimer data-id="element-11" />
            </span>
          </div>
          <div className="text-[11px] md:text-xs text-slate-400 mt-1 text-center font-medium tracking-wide" data-id="element-12">
            Últimos <span className="text-red-400 font-bold" data-id="element-13">4 cupos</span> al
            precio promocional + 6 bonus
          </div>
        </div>
      </div>

      {/* Hero Section */}
      <section className="w-full bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-slate-800 via-slate-900 to-black py-12 px-4 relative overflow-hidden" data-id="element-14">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-72 bg-amber-400/15 rounded-full blur-3xl pointer-events-none" data-id="element-15"></div>
        <div className="absolute bottom-0 left-1/4 w-72 h-72 bg-yellow-500/10 rounded-full blur-3xl pointer-events-none" data-id="element-16"></div>
        <div className="absolute inset-0 opacity-[0.04] pointer-events-none" style={{
        backgroundImage: 'linear-gradient(rgba(255,255,255,0.6) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.6) 1px, transparent 1px)',
        backgroundSize: '48px 48px'
      }} data-id="element-17"></div>
        <div className="max-w-5xl mx-auto text-center relative z-10" data-id="element-18">
          <div className="flex justify-center mb-6" data-id="element-19">
            <div className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full border border-yellow-500/30 bg-slate-900/60 backdrop-blur-md shadow-[0_0_20px_rgba(234,179,8,0.15)] hover:shadow-[0_0_30px_rgba(234,179,8,0.25)] transition-shadow duration-300" data-id="element-20">
              <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse" data-id="element-21"></div>
              <span className="text-xs md:text-sm font-bold uppercase tracking-widest" data-id="element-22">
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-200 to-yellow-500" data-id="element-23">
                  Para NOVELES ABOGADOS
                </span>
                <span className="text-slate-300 font-medium" data-id="element-24">
                  {' '}
                  <span className="mx-1 text-slate-600" data-id="element-25">|</span> Válido para
                  toda la Argentina 🇦🇷
                </span>
              </span>
            </div>
          </div>

          <h1 className="text-4xl md:text-6xl font-black text-white mb-6 leading-tight uppercase text-center tracking-tight" data-id="element-26">
            <span className="relative inline-block" data-id="element-27">
              <span className="relative z-10 text-transparent bg-clip-text bg-gradient-to-r from-yellow-300 to-yellow-500 drop-shadow-[0_0_15px_rgba(234,179,8,0.3)]" data-id="element-28">
                Ahorrá 1 año
              </span>
            </span>{' '}
            de tiempo y{' '}
            <span className="relative inline-block" data-id="element-29">
              <span className="relative z-10 text-transparent bg-clip-text bg-gradient-to-r from-red-400 to-red-600 drop-shadow-[0_0_15px_rgba(239,68,68,0.3)]" data-id="element-30">
                evitá errores
              </span>
            </span>{' '}
            de amateur en tu{' '}
            <span className="relative inline-block" data-id="element-31">
              <span className="relative z-10 text-white drop-shadow-[0_0_10px_rgba(255,255,255,0.2)]" data-id="element-32">
                primer año
              </span>
              <span className="absolute bottom-1 left-0 w-full h-2 bg-yellow-500/40 -z-0 rounded-full blur-[1px]" data-id="element-33"></span>
            </span>{' '}
            como abogado
          </h1>

          <a href={PURCHASE_URL} className="block max-w-2xl mx-auto mb-8 relative group" data-id="element-34">
            <div className="absolute inset-0 bg-yellow-500/20 rounded-2xl blur-2xl group-hover:bg-yellow-500/30 transition-all duration-500" data-id="element-35"></div>
            <img src="https://cdn.magicpatterns.com/uploads/iJJdpCyfxh5BQG3hJzFyXz/PRESENTACION_ERICA_Y_JIME_-_VIERNES_12_DE_JUNIO.png" alt="Mega Pack de Procuración Jurídica 2026" className="w-full h-auto relative z-10 group-hover:scale-105 transition-transform duration-500 drop-shadow-2xl" data-id="element-36" />
          </a>

          <h2 className="text-xl md:text-2xl text-yellow-400 mb-4 max-w-3xl mx-auto font-bold leading-relaxed text-center tracking-wide" data-id="element-37">
            TUS PRIMEROS PASOS EN LA PRÁCTICA PROFESIONAL Y PROCURACIÓN JURÍDICA
          </h2>

          <p className="text-lg md:text-xl text-slate-300 mb-8 max-w-3xl mx-auto text-center font-light leading-relaxed" data-id="element-38">
            Un sistema listo para usar para que dejes de improvisar y empieces a
            ejercer con{' '}
            <span className="font-semibold text-white" data-id="element-39">seguridad</span>, sin
            perder semanas en prueba y error.
          </p>

          <div className="bg-slate-900/80 backdrop-blur-xl rounded-3xl shadow-[0_0_40px_rgba(234,179,8,0.15)] p-8 md:p-10 max-w-3xl mx-auto mt-4 mb-8 border border-yellow-500/20 relative overflow-hidden" data-id="element-40">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-yellow-600 via-yellow-400 to-yellow-600" data-id="element-41"></div>
            <h3 className="text-2xl md:text-3xl font-black text-white mb-8 uppercase text-center tracking-wide" data-id="element-42">
              GUÍA PASO A PASO DE PROCURACIÓN JURÍDICA 2026{' '}
              <span className="text-yellow-400" data-id="element-43">+ 6 BONUS</span>
            </h3>
            <div className="grid md:grid-cols-2 gap-5 text-left" data-id="element-44">
              {['Escrito + estructura + orden (sin caos mental)', 'Paso a paso real (lo que en la facu no te dicen)', 'Subida al PJN sin trabarte (fueros principales)', 'Honorarios con criterio (sin regalar tu laburo)', 'Primera entrevista con clientes sin quedarte en blanco', 'Comunidad +583 colegas para destrabarte rápido'].map((text, i) => <div key={i} className="flex items-start gap-3 bg-slate-800/50 p-4 rounded-xl border border-slate-700/50 hover:border-yellow-500/30 transition-colors" data-id="element-45">
                  <div className="bg-green-500/20 rounded-full p-1 flex-shrink-0 mt-0.5" data-id="element-46">
                    <CheckIcon className="h-4 w-4 text-green-400" data-id="element-47" />
                  </div>
                  <span className="text-slate-300 text-sm md:text-base font-medium" data-id="element-48">
                    {text}
                  </span>
                </div>)}
            </div>
          </div>

          <p className="text-sm font-bold text-yellow-400 mb-4 text-center drop-shadow-[0_0_10px_rgba(234,179,8,0.4)]" data-id="element-49">
            ⭐ Garantía de satisfacción 7 días ⭐
          </p>
        </div>
      </section>

      {/* Problem Section */}
      <section className="w-full bg-[#f8fafc] py-12 px-4 relative overflow-hidden" data-id="element-50">
        <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-slate-300 to-transparent" data-id="element-51"></div>
        <div className="absolute top-1/2 left-0 w-96 h-96 bg-red-500/5 rounded-full blur-3xl pointer-events-none" data-id="element-52"></div>
        <div className="absolute top-1/2 right-0 w-96 h-96 bg-amber-500/5 rounded-full blur-3xl pointer-events-none" data-id="element-53"></div>

        <div className="max-w-4xl mx-auto relative z-10" data-id="element-54">
          <h2 className="text-3xl md:text-5xl font-black text-slate-900 mb-10 text-center uppercase leading-tight tracking-tight" data-id="element-55">
            Si sos novel abogado, dejame hacerte una pregunta honesta:
          </h2>

          <div className="bg-white rounded-3xl shadow-[0_20px_50px_-12px_rgba(0,0,0,0.1)] p-8 md:p-12 mb-10 border border-slate-100 relative overflow-hidden" data-id="element-56">
            <div className="absolute top-0 left-0 w-full h-1 bg-red-500" data-id="element-57"></div>
            <p className="text-2xl md:text-4xl font-black text-red-600 mb-8 text-center tracking-tight" data-id="element-58">
              ¿Te pasa que el miedo a equivocarte te hace tardar el triple?
            </p>
            <p className="text-lg md:text-xl text-slate-600 mb-8 text-center font-medium" data-id="element-59">
              Porque una cosa es saber Derecho… y otra muy distinta es ejercer
              en el mundo real, donde:
            </p>
            <div className="grid md:grid-cols-2 gap-4" data-id="element-60">
              {['Un detalle te puede hacer perder días', 'Un formato mal armado te lo rebotan', 'Un cliente te pregunta "¿y ahora qué sigue?" (y no quiere teoría 😅)', 'Y el PJN… bueno, el PJN no perdona distracciones'].map((text, i) => <div key={i} className="flex items-start gap-4 bg-red-50/50 p-5 rounded-2xl border border-red-100" data-id="element-61">
                  <div className="bg-red-100 rounded-full p-1.5 flex-shrink-0 mt-0.5" data-id="element-62">
                    <XIcon className="h-5 w-5 text-red-500" data-id="element-63" />
                  </div>
                  <span className="text-slate-700 font-medium leading-relaxed" data-id="element-64">
                    {text}
                  </span>
                </div>)}
            </div>
            <div className="mt-10 text-center" data-id="element-65">
              <p className="inline-block bg-red-50 text-red-700 px-6 py-3 rounded-full text-lg font-bold border border-red-100" data-id="element-66">
                No es que no sepas. Es que nadie te dio el paso a paso real.
              </p>
            </div>
          </div>

          <div className="bg-slate-900 text-white rounded-3xl shadow-[0_20px_50px_-12px_rgba(0,0,0,0.3)] p-8 md:p-12 mb-8 border border-slate-800 relative overflow-hidden" data-id="element-67">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-yellow-600 via-yellow-400 to-yellow-600" data-id="element-68"></div>
            <div className="absolute -right-20 -top-20 w-64 h-64 bg-yellow-500/10 rounded-full blur-3xl pointer-events-none" data-id="element-69"></div>
            <h3 className="text-2xl md:text-4xl font-black mb-8 text-transparent bg-clip-text bg-gradient-to-r from-yellow-200 to-yellow-500 uppercase text-center tracking-tight" data-id="element-70">
              El problema que nadie dice en voz alta (pero todos viven)
            </h3>
            <p className="text-lg md:text-xl mb-8 text-slate-300 text-center font-light" data-id="element-71">
              En tu primer año, es normal que pase esto:
            </p>
            <div className="grid md:grid-cols-2 gap-5" data-id="element-72">
              {['Tenés conocimiento… pero no tenés sistema', 'Te cuesta saber "qué va primero" y "qué no se toca"', 'Perdés horas buscando modelos (y ninguno coincide)', 'Dudás con requisitos, adjuntos, formatos, presentación', 'Te frena el miedo al error "de principiante"', 'Te agarran casos y sentís que estás corriendo atrás de todo'].map((text, i) => <div key={i} className="flex items-start gap-4 bg-slate-800/50 p-4 rounded-xl border border-slate-700/50" data-id="element-73">
                  <div className="bg-yellow-500/20 rounded-full p-1 flex-shrink-0 mt-0.5" data-id="element-74">
                    <CheckIcon className="h-4 w-4 text-yellow-400" data-id="element-75" />
                  </div>
                  <span className="text-slate-200 font-medium" data-id="element-76">{text}</span>
                </div>)}
            </div>
            <div className="mt-10 bg-red-500/10 border border-red-500/20 rounded-2xl p-6 text-center" data-id="element-77">
              <p className="text-xl md:text-2xl font-bold text-red-400" data-id="element-78">
                Y lo peor: laburás mucho, avanzás poco, y vivís con la sensación
                de estar siempre atrás.
              </p>
            </div>
          </div>

          {/* → scroll a oferta */}
        </div>
      </section>

      {/* Solution Section */}
      <section className="w-full bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-slate-900 via-slate-950 to-black text-white py-14 px-4 border-t border-slate-800 relative overflow-hidden" data-id="element-79">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-5xl h-full bg-yellow-500/5 rounded-full blur-[100px] pointer-events-none" data-id="element-80"></div>
        <div className="absolute inset-0 opacity-[0.02] pointer-events-none" style={{
        backgroundImage: 'linear-gradient(rgba(255,255,255,1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,1) 1px, transparent 1px)',
        backgroundSize: '64px 64px'
      }} data-id="element-81"></div>

        <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-82">
          <div className="inline-flex items-center gap-2 bg-yellow-500/10 border border-yellow-500/30 text-yellow-400 font-bold text-sm md:text-base px-6 py-2 rounded-full mb-8 uppercase tracking-widest shadow-[0_0_20px_rgba(234,179,8,0.15)]" data-id="element-83">
            <span className="animate-pulse" data-id="element-84">⚖️</span> LA SOLUCIÓN
          </div>
          <h2 className="text-4xl md:text-6xl font-black mb-8 uppercase text-center tracking-tight" data-id="element-85">
            GUÍA PASO A PASO DE <br data-id="element-86" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-200 via-yellow-400 to-yellow-200 drop-shadow-[0_0_15px_rgba(234,179,8,0.2)]" data-id="element-87">
              PROCURACIÓN JURÍDICA 2026
            </span>{' '}
            <br data-id="element-88" />
            <span className="text-3xl md:text-4xl text-white" data-id="element-89">+ 6 BONUS</span>
          </h2>
          <p className="text-xl md:text-2xl mb-14 text-slate-300 text-center font-light leading-relaxed max-w-3xl mx-auto" data-id="element-90">
            Un sistema práctico para que tus primeros pasos sean claros,
            ordenados y{' '}
            <span className="font-semibold text-white" data-id="element-91">profesionales</span>,
            válido para toda Argentina 🇦🇷
          </p>

          <div className="bg-slate-800/40 backdrop-blur-xl rounded-3xl p-8 md:p-12 mb-14 border border-slate-700/50 shadow-2xl relative overflow-hidden" data-id="element-92">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-slate-700 via-slate-400 to-slate-700" data-id="element-93"></div>
            <h3 className="text-2xl md:text-3xl font-black mb-10 text-white uppercase text-center tracking-wide" data-id="element-94">
              Cómo se usa <span className="text-yellow-400" data-id="element-95">(en 3 pasos)</span>
            </h3>
            <div className="grid md:grid-cols-3 gap-6 md:gap-8" data-id="element-96">
              {[{
              step: '1',
              text: 'Abrís la guía'
            }, {
              step: '2',
              text: 'Elegís el trámite / situación'
            }, {
              step: '3',
              text: 'Aplicás el paso a paso + material listo'
            }].map((item, i) => <div key={i} className="bg-slate-900/80 rounded-2xl p-8 text-center border border-slate-700/50 hover:border-yellow-500/30 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_10px_30px_rgba(0,0,0,0.5)] group" data-id="element-97">
                  <div className="w-16 h-16 mx-auto bg-slate-800 rounded-full flex items-center justify-center mb-6 border border-slate-600 group-hover:border-yellow-500/50 group-hover:bg-yellow-500/10 transition-colors" data-id="element-98">
                    <span className="text-3xl font-black text-yellow-400" data-id="element-99">
                      {item.step}
                    </span>
                  </div>
                  <p className="text-lg md:text-xl font-medium text-slate-200" data-id="element-100">
                    {item.text}
                  </p>
                </div>)}
            </div>
            <div className="mt-10 inline-block bg-yellow-500/10 border border-yellow-500/20 rounded-full px-8 py-3" data-id="element-101">
              <p className="text-lg md:text-xl font-bold text-yellow-400 text-center" data-id="element-102">
                Sin vueltas. Sin improvisar. Sin perder tiempo.
              </p>
            </div>
          </div>

          {/* → scroll a oferta */}
          <a href="#compra" onClick={scrollToOffer} className="inline-block bg-gradient-to-r from-green-500 to-green-600 text-white font-black text-xl md:text-2xl px-12 py-6 rounded-xl shadow-[0_0_30px_rgba(34,197,94,0.3)] hover:shadow-[0_0_50px_rgba(34,197,94,0.5)] transform hover:scale-105 transition-all duration-300 animate-pulse-slow uppercase text-center border-2 border-green-400" data-id="element-103">
            QUIERO MI MEGAPACK
          </a>
        </div>
      </section>

      {/* What's Included Section */}
      <section className="w-full bg-gradient-to-b from-white via-slate-50 to-white py-10 px-4 relative overflow-hidden" data-id="element-104">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-2xl h-64 bg-amber-400/5 rounded-full blur-3xl pointer-events-none" data-id="element-105"></div>
        <div className="max-w-5xl mx-auto text-center relative z-10" data-id="element-106">
          <h2 className="text-3xl md:text-5xl font-black text-slate-900 mb-6 uppercase text-center" data-id="element-107">
            ¿Qué incluye exactamente?
          </h2>

          <div className="bg-slate-50 rounded-xl shadow-xl p-8 mb-8 border border-slate-200" data-id="element-108">
            <div className="flex items-center justify-center gap-3 mb-4" data-id="element-109">
              <StarIcon className="h-8 w-8 text-yellow-500 fill-yellow-500" data-id="element-110" />
              <h3 className="text-2xl md:text-3xl font-black text-slate-900 uppercase text-center" data-id="element-111">
                Producto principal
              </h3>
            </div>
            <a href="#compra" onClick={scrollToOffer} className="block mb-4" data-id="element-112">
              <img src="https://cdn.magicpatterns.com/uploads/gN2kG2xBBMWAFKYTTxmgEw/Guia_de_procuracion_juridica_Paso_a_paso.png" alt="Guía Paso a Paso de Procuración Jurídica 2026" className="w-full max-w-xl mx-auto h-auto rounded-lg shadow-lg hover:scale-105 transition-transform duration-300" style={{
              aspectRatio: '1/1',
              objectFit: 'cover'
            }} data-id="element-113" />
            </a>
            <h4 className="text-2xl font-bold text-slate-900 mb-3 text-center" data-id="element-114">
              GUÍA PASO A PASO DE PROCURACIÓN JURÍDICA 2026
            </h4>
            <p className="text-lg text-slate-700 mb-3 text-center" data-id="element-115">
              Pensada para noveles abogados que necesitan:
            </p>
            <ul className="space-y-3 text-slate-800 max-w-md mx-auto text-left" data-id="element-116">
              <li className="flex items-start gap-3" data-id="element-117">
                <CheckIcon className="h-6 w-6 text-green-600 flex-shrink-0 mt-1" data-id="element-118" />
                <span data-id="element-119">Orden mental (qué va primero, qué va después)</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-120">
                <CheckIcon className="h-6 w-6 text-green-600 flex-shrink-0 mt-1" data-id="element-121" />
                <span data-id="element-122">Ejecución (no "información para leer algún día")</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-123">
                <CheckIcon className="h-6 w-6 text-green-600 flex-shrink-0 mt-1" data-id="element-124" />
                <span data-id="element-125">Una ruta clara para actuar con criterio y rapidez</span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* Bonuses Section */}
      <section className="w-full bg-gradient-to-b from-slate-50 via-slate-100 to-slate-50 pt-6 pb-10 px-4 relative overflow-hidden" data-id="element-126">
        <div className="absolute top-0 right-0 w-96 h-96 bg-yellow-400/5 rounded-full blur-3xl pointer-events-none" data-id="element-127"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-yellow-400/5 rounded-full blur-3xl pointer-events-none" data-id="element-128"></div>
        <div className="max-w-6xl mx-auto relative z-10" data-id="element-129">
          <div className="bg-slate-900 rounded-xl p-6 mb-6 text-center border-t-4 border-yellow-500" data-id="element-130">
            <h2 className="text-3xl md:text-5xl font-black text-yellow-400 uppercase text-center" data-id="element-131">
              🎁 BONUS INCLUIDOS HOY
            </h2>
            <p className="text-xl font-bold text-white mt-2 text-center" data-id="element-132">
              (sin costo adicional)
            </p>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-6 mb-6 text-center border border-slate-200" data-id="element-133">
            <p className="text-2xl font-bold text-red-900 uppercase text-center" data-id="element-134">
              ⚡ Estos bonos son GRATIS por el día de hoy ⚡
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-8" data-id="element-135">
            <a href="#compra" onClick={scrollToOffer} className="block" data-id="element-136">
              <div className="bg-white rounded-2xl shadow-[0_0_20px_rgba(0,0,0,0.05)] hover:shadow-[0_0_35px_rgba(234,179,8,0.25)] hover:-translate-y-1 transition-all duration-300 border border-slate-200 hover:border-yellow-400/60 overflow-hidden group" data-id="element-137">
                <div className="w-full relative" style={{
                aspectRatio: '1/1'
              }} data-id="element-138">
                  <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10" data-id="element-139"></div>
                  <img src="https://cdn.magicpatterns.com/uploads/dmZen66tPjYDX1sotCwXwK/Bonus_1.png" alt="Bonus 1" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-140" />
                </div>
                <div className="p-6 text-center relative bg-white" data-id="element-141">
                  <h3 className="text-xl font-bold text-slate-900 mb-3 text-center group-hover:text-amber-600 transition-colors" data-id="element-142">
                    ✅ BONUS 1: Introducción – Escritos Judiciales Paso a Paso
                  </h3>
                  <p className="text-slate-700" data-id="element-143">
                    Para dejar de armar escritos "a ojo" y entender: estructura,
                    lógica, qué va / qué no va, errores típicos de principiante
                    que te hacen perder tiempo.
                  </p>
                  <div className="mt-4 flex items-center justify-center gap-2" data-id="element-144">
                    <span className="text-slate-400 line-through font-bold" data-id="element-145">
                      ARS 14.990
                    </span>
                    <span className="bg-green-100 text-green-700 font-black text-sm px-3 py-1 rounded-full border border-green-300" data-id="element-146">
                      HOY GRATIS
                    </span>
                  </div>
                </div>
              </div>
            </a>

            <a href="#compra" onClick={scrollToOffer} className="block" data-id="element-147">
              <div className="bg-white rounded-2xl shadow-[0_0_20px_rgba(0,0,0,0.05)] hover:shadow-[0_0_35px_rgba(234,179,8,0.25)] hover:-translate-y-1 transition-all duration-300 border border-slate-200 hover:border-yellow-400/60 overflow-hidden group" data-id="element-148">
                <div className="w-full relative" style={{
                aspectRatio: '1/1'
              }} data-id="element-149">
                  <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10" data-id="element-150"></div>
                  <img src="https://cdn.magicpatterns.com/uploads/vo6eXqb7q1Dns49oikMBZ8/Bonus_2.png" alt="Bonus 2" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-151" />
                </div>
                <div className="p-6 text-center relative bg-white" data-id="element-152">
                  <h3 className="text-xl font-bold text-slate-900 mb-3 text-center group-hover:text-amber-600 transition-colors" data-id="element-153">
                    ✅ BONUS 2: Guía Completa: Cómo Subir un Escrito al Portal
                    del PJN
                  </h3>
                  <p className="text-slate-700" data-id="element-154">
                    Para que el PJN no te coma la cabeza: paso a paso claro,
                    checklist previo a subir, cómo evitar trabas comunes,
                    presentación sin pánico.
                  </p>
                  <div className="mt-4 flex items-center justify-center gap-2" data-id="element-155">
                    <span className="text-slate-400 line-through font-bold" data-id="element-156">
                      ARS 18.990
                    </span>
                    <span className="bg-green-100 text-green-700 font-black text-sm px-3 py-1 rounded-full border border-green-300" data-id="element-157">
                      HOY GRATIS
                    </span>
                  </div>
                </div>
              </div>
            </a>

            <a href="#compra" onClick={scrollToOffer} className="block" data-id="element-158">
              <div className="bg-white rounded-2xl shadow-[0_0_20px_rgba(0,0,0,0.05)] hover:shadow-[0_0_35px_rgba(234,179,8,0.25)] hover:-translate-y-1 transition-all duration-300 border border-slate-200 hover:border-yellow-400/60 overflow-hidden group" data-id="element-159">
                <div className="w-full relative" style={{
                aspectRatio: '1/1'
              }} data-id="element-160">
                  <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10" data-id="element-161"></div>
                  <img src="https://cdn.magicpatterns.com/uploads/xw4C8Bo7tFvuqQ8dBb9i9d/Bonus_3.png" alt="Bonus 3" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-162" />
                </div>
                <div className="p-6 text-center relative bg-white" data-id="element-163">
                  <h3 className="text-xl font-bold text-slate-900 mb-3 text-center group-hover:text-amber-600 transition-colors" data-id="element-164">
                    ✅ BONUS 3: Guía Práctica de Honorarios Profesionales
                    (Argentina)
                  </h3>
                  <p className="text-slate-700" data-id="element-165">
                    Para que no te pase el clásico: "¿Cuánto cobro?" → silencio
                    incómodo. Acá tenés criterio para presupuestar y cobrar sin
                    regalarte.
                  </p>
                  <div className="mt-4 flex items-center justify-center gap-2" data-id="element-166">
                    <span className="text-slate-400 line-through font-bold" data-id="element-167">
                      ARS 16.990
                    </span>
                    <span className="bg-green-100 text-green-700 font-black text-sm px-3 py-1 rounded-full border border-green-300" data-id="element-168">
                      HOY GRATIS
                    </span>
                  </div>
                </div>
              </div>
            </a>
          </div>

          <div className="grid md:grid-cols-3 gap-6" data-id="element-169">
            <a href="#compra" onClick={scrollToOffer} className="block" data-id="element-170">
              <div className="bg-white rounded-2xl shadow-[0_0_20px_rgba(0,0,0,0.05)] hover:shadow-[0_0_35px_rgba(234,179,8,0.25)] hover:-translate-y-1 transition-all duration-300 border border-slate-200 hover:border-yellow-400/60 overflow-hidden group" data-id="element-171">
                <div className="w-full relative" style={{
                aspectRatio: '1/1'
              }} data-id="element-172">
                  <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10" data-id="element-173"></div>
                  <img src="https://cdn.magicpatterns.com/uploads/r3X8EagC5xJm8b4HKhFQbT/Bonus_4.png" alt="Bonus 4" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-174" />
                </div>
                <div className="p-6 text-center relative bg-white" data-id="element-175">
                  <h3 className="text-xl font-bold text-slate-900 mb-3 text-center group-hover:text-amber-600 transition-colors" data-id="element-176">
                    ✅ BONUS 4: Guía Práctica: Tu Primera Entrevista con
                    Clientes
                  </h3>
                  <p className="text-slate-700" data-id="element-177">
                    Para que la entrevista no sea un caos: qué preguntar, cómo
                    ordenar el caso, cómo transmitir seguridad sin humo, cómo
                    salir con próximos pasos claros.
                  </p>
                  <div className="mt-4 flex items-center justify-center gap-2" data-id="element-178">
                    <span className="text-slate-400 line-through font-bold" data-id="element-179">
                      ARS 12.990
                    </span>
                    <span className="bg-green-100 text-green-700 font-black text-sm px-3 py-1 rounded-full border border-green-300" data-id="element-180">
                      HOY GRATIS
                    </span>
                  </div>
                </div>
              </div>
            </a>

            <a href="#compra" onClick={scrollToOffer} className="block" data-id="element-181">
              <div className="bg-white rounded-2xl shadow-[0_0_20px_rgba(0,0,0,0.05)] hover:shadow-[0_0_35px_rgba(234,179,8,0.25)] hover:-translate-y-1 transition-all duration-300 border border-slate-200 hover:border-yellow-400/60 overflow-hidden group" data-id="element-182">
                <div className="w-full relative" style={{
                aspectRatio: '1/1'
              }} data-id="element-183">
                  <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10" data-id="element-184"></div>
                  <img src="https://cdn.magicpatterns.com/uploads/aP8hCyUAzELr5zghVNRPmQ/Bonus_5.png" alt="Bonus 5" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-185" />
                </div>
                <div className="p-6 text-center relative bg-white" data-id="element-186">
                  <h3 className="text-xl font-bold text-slate-900 mb-3 text-center group-hover:text-amber-600 transition-colors" data-id="element-187">
                    ✅ BONUS 5: Pasos Previos al Ejercicio Profesional
                  </h3>
                  <p className="text-slate-700" data-id="element-188">
                    Checklist para empezar bien: orden básico, preparación
                    práctica, prevención de errores por apuro.
                  </p>
                  <div className="mt-4 flex items-center justify-center gap-2" data-id="element-189">
                    <span className="text-slate-400 line-through font-bold" data-id="element-190">
                      ARS 10.990
                    </span>
                    <span className="bg-green-100 text-green-700 font-black text-sm px-3 py-1 rounded-full border border-green-300" data-id="element-191">
                      HOY GRATIS
                    </span>
                  </div>
                </div>
              </div>
            </a>

            <a href="#compra" onClick={scrollToOffer} className="block" data-id="element-192">
              <div className="bg-white rounded-2xl shadow-[0_0_30px_rgba(234,179,8,0.25)] hover:shadow-[0_0_45px_rgba(234,179,8,0.4)] hover:-translate-y-1 transition-all duration-300 border-2 border-yellow-500 overflow-hidden group relative" data-id="element-193">
                <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-yellow-300 via-amber-500 to-yellow-300 z-20" data-id="element-194"></div>
                <div className="w-full relative" style={{
                aspectRatio: '1/1'
              }} data-id="element-195">
                  <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10" data-id="element-196"></div>
                  <img src="https://cdn.magicpatterns.com/uploads/m4unkkyeQbYhT7YdQ3UiF8/Bonus_6.png" alt="Bonus 6" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-197" />
                </div>
                <div className="p-6 text-center relative bg-white" data-id="element-198">
                  <h3 className="text-xl font-bold text-slate-900 mb-3 text-center group-hover:text-amber-600 transition-colors" data-id="element-199">
                    ✅ BONUS 6: GRUPO DE WHATSAPP (+580 colegas)
                  </h3>
                  <p className="text-slate-700" data-id="element-200">
                    Cuando aparece esa duda que te frena: entrás, preguntás,
                    destrabás y seguís.
                  </p>
                  <div className="mt-4 flex items-center justify-center gap-2" data-id="element-201">
                    <span className="text-slate-400 line-through font-bold" data-id="element-202">
                      ARS 24.990
                    </span>
                    <span className="bg-green-100 text-green-700 font-black text-sm px-3 py-1 rounded-full border border-green-300" data-id="element-203">
                      HOY GRATIS
                    </span>
                  </div>
                  <div className="mt-3 flex items-center justify-center gap-2 text-green-600 font-semibold" data-id="element-204">
                    <UsersIcon className="h-5 w-5" data-id="element-205" />
                    <span data-id="element-206">Comunidad activa</span>
                  </div>
                </div>
              </div>
            </a>
          </div>

          {/* Bonuses savings summary */}
          <div className="mt-10 max-w-3xl mx-auto bg-slate-900 rounded-3xl p-8 md:p-10 text-center border-2 border-green-500 shadow-[0_0_40px_rgba(34,197,94,0.2)] relative overflow-hidden" data-id="element-207">
            <div className="absolute top-0 left-0 w-full h-1.5 bg-gradient-to-r from-green-400 via-green-500 to-green-400" data-id="element-208"></div>
            <div className="absolute -top-16 left-1/2 -translate-x-1/2 w-64 h-32 bg-green-500/20 rounded-full blur-3xl pointer-events-none" data-id="element-209"></div>
            <p className="text-sm md:text-base font-bold uppercase tracking-widest text-green-400 mb-3 relative z-10" data-id="element-210">
              💰 Solo en bonus te estás llevando GRATIS
            </p>
            <div className="flex items-center justify-center gap-3 mb-3 relative z-10" data-id="element-211">
              <span className="text-2xl md:text-3xl text-slate-500 line-through font-bold" data-id="element-212">
                ARS 98.940
              </span>
            </div>
            <p className="text-5xl md:text-7xl font-black text-transparent bg-clip-text bg-gradient-to-br from-green-300 via-green-400 to-green-500 leading-none mb-4 relative z-10 drop-shadow-[0_0_20px_rgba(34,197,94,0.3)]" data-id="element-213">
              ARS 0
            </p>
            <p className="inline-block bg-green-500/10 border border-green-500/30 text-green-300 font-black text-lg md:text-2xl px-6 py-3 rounded-2xl relative z-10" data-id="element-214">
              ✅ Ahorrás ARS 98.940 en bonus — solo por hoy
            </p>
            <p className="text-sm text-slate-400 mt-4 relative z-10" data-id="element-215">
              6 bonus valuados en ARS 98.940, incluidos sin costo adicional con
              tu MegaPack.
            </p>
          </div>
        </div>
      </section>

      {/* Before/After Section */}
      <section className="w-full bg-gradient-to-b from-white via-slate-50 to-white py-10 px-4 relative overflow-hidden" data-id="element-216">
        <div className="absolute top-1/2 left-0 w-64 h-64 bg-red-400/5 rounded-full blur-3xl pointer-events-none" data-id="element-217"></div>
        <div className="absolute top-1/2 right-0 w-64 h-64 bg-green-400/5 rounded-full blur-3xl pointer-events-none" data-id="element-218"></div>
        <div className="max-w-6xl mx-auto relative z-10" data-id="element-219">
          <h2 className="text-3xl md:text-5xl font-black text-slate-900 mb-8 text-center uppercase" data-id="element-220">
            ⚔️ Antes vs Después
          </h2>
          <div className="grid md:grid-cols-2 gap-8" data-id="element-221">
            <div className="bg-red-50 rounded-3xl shadow-[0_0_40px_rgba(220,38,38,0.15)] p-8 border-2 border-red-300 relative overflow-hidden" data-id="element-222">
              <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-red-300 via-red-500 to-red-300" data-id="element-223"></div>
              <div className="absolute -bottom-20 -right-20 w-40 h-40 bg-red-400/20 rounded-full blur-3xl" data-id="element-224"></div>
              <h3 className="text-2xl font-black text-red-800 mb-6 uppercase text-center relative z-10" data-id="element-225">
                Antes (primer año modo supervivencia)
              </h3>
              <div className="space-y-4" data-id="element-226">
                <div className="flex items-start gap-3" data-id="element-227">
                  <XIcon className="h-6 w-6 text-red-700 flex-shrink-0 mt-1" data-id="element-228" />
                  <span className="text-slate-800" data-id="element-229">Dudas constantes</span>
                </div>
                <div className="flex items-start gap-3" data-id="element-230">
                  <XIcon className="h-6 w-6 text-red-700 flex-shrink-0 mt-1" data-id="element-231" />
                  <span className="text-slate-800" data-id="element-232">
                    Horas perdidas buscando modelos
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-233">
                  <XIcon className="h-6 w-6 text-red-700 flex-shrink-0 mt-1" data-id="element-234" />
                  <span className="text-slate-800" data-id="element-235">
                    Miedo a errores "tontos"
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-236">
                  <XIcon className="h-6 w-6 text-red-700 flex-shrink-0 mt-1" data-id="element-237" />
                  <span className="text-slate-800" data-id="element-238">Honorarios a ojo</span>
                </div>
                <div className="flex items-start gap-3" data-id="element-239">
                  <XIcon className="h-6 w-6 text-red-700 flex-shrink-0 mt-1" data-id="element-240" />
                  <span className="text-slate-800" data-id="element-241">
                    Entrevistas sin estructura
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-242">
                  <XIcon className="h-6 w-6 text-red-700 flex-shrink-0 mt-1" data-id="element-243" />
                  <span className="text-slate-800" data-id="element-244">
                    Sensación de "me falta algo"
                  </span>
                </div>
              </div>
            </div>

            <div className="bg-green-50 rounded-3xl shadow-[0_0_40px_rgba(34,197,94,0.15)] p-8 border-2 border-green-500 relative overflow-hidden" data-id="element-245">
              <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-green-300 via-green-500 to-green-300" data-id="element-246"></div>
              <div className="absolute -bottom-20 -left-20 w-40 h-40 bg-green-400/20 rounded-full blur-3xl" data-id="element-247"></div>
              <h3 className="text-2xl font-black text-green-800 mb-6 uppercase text-center relative z-10" data-id="element-248">
                Después (primer año con sistema)
              </h3>
              <div className="space-y-4" data-id="element-249">
                <div className="flex items-start gap-3" data-id="element-250">
                  <CheckIcon className="h-6 w-6 text-green-700 flex-shrink-0 mt-1" data-id="element-251" />
                  <span className="text-slate-800" data-id="element-252">
                    Pasos claros y ordenados
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-253">
                  <CheckIcon className="h-6 w-6 text-green-700 flex-shrink-0 mt-1" data-id="element-254" />
                  <span className="text-slate-800" data-id="element-255">
                    Material listo para aplicar
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-256">
                  <CheckIcon className="h-6 w-6 text-green-700 flex-shrink-0 mt-1" data-id="element-257" />
                  <span className="text-slate-800" data-id="element-258">
                    Más seguridad al presentar
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-259">
                  <CheckIcon className="h-6 w-6 text-green-700 flex-shrink-0 mt-1" data-id="element-260" />
                  <span className="text-slate-800" data-id="element-261">Menos tiempo perdido</span>
                </div>
                <div className="flex items-start gap-3" data-id="element-262">
                  <CheckIcon className="h-6 w-6 text-green-700 flex-shrink-0 mt-1" data-id="element-263" />
                  <span className="text-slate-800" data-id="element-264">
                    Honorarios con criterio
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-265">
                  <CheckIcon className="h-6 w-6 text-green-700 flex-shrink-0 mt-1" data-id="element-266" />
                  <span className="text-slate-800" data-id="element-267">
                    Entrevistas que terminan en "siguiente paso"
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* What You Get Today Section */}
      <section className="w-full bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-slate-800 via-slate-900 to-black text-white py-12 px-4 border-t-4 border-yellow-500 relative overflow-hidden" data-id="element-268">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-full bg-yellow-500/5 rounded-full blur-3xl pointer-events-none" data-id="element-269"></div>
        <div className="max-w-5xl mx-auto relative z-10" data-id="element-270">
          <div className="text-center mb-12" data-id="element-271">
            <h2 className="text-4xl md:text-6xl font-black uppercase text-yellow-400 drop-shadow-lg mb-4" data-id="element-272">
              🧾 Todo lo que te llevás hoy
            </h2>
            <p className="text-xl text-slate-300 font-medium" data-id="element-273">
              Un sistema completo diseñado para que no tengas que improvisar
              nunca más.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-274">
            {[{
            title: 'Guía Paso a Paso 2026',
            desc: 'El sistema central de procuración jurídica argentina.',
            icon: AwardIcon
          }, {
            title: 'Bonus 1: Escritos Judiciales',
            desc: 'Modelos y estructuras listas para usar.',
            icon: DownloadIcon
          }, {
            title: 'Bonus 2: Portal PJN',
            desc: 'Guía técnica para no trabarte nunca al subir escritos.',
            icon: ZapIcon
          }, {
            title: 'Bonus 3: Honorarios Prof.',
            desc: 'Criterios reales para cobrar lo que corresponde.',
            icon: ShieldIcon
          }, {
            title: 'Bonus 4: Primera Entrevista',
            desc: 'Cómo cerrar clientes y transmitir seguridad.',
            icon: UsersIcon
          }, {
            title: 'Bonus 5: Pasos Previos',
            desc: 'Checklist indispensable antes de empezar a ejercer.',
            icon: ClockIcon
          }, {
            title: 'Bonus 6: Grupo WhatsApp',
            desc: 'Acceso a +583 colegas para consultas en tiempo real.',
            icon: UsersIcon
          }, {
            title: 'Acceso de por vida',
            desc: 'Descarga digital inmediata y actualizaciones gratis.',
            icon: ZapIcon
          }].map((item, i) => <div key={i} className="bg-slate-800/50 border border-slate-700 rounded-2xl p-6 flex items-start gap-4 hover:bg-slate-800 hover:border-yellow-500/50 hover:shadow-[0_0_25px_rgba(234,179,8,0.15)] transition-all duration-300 group relative overflow-hidden" data-id="element-275">
                <div className="absolute inset-0 bg-gradient-to-br from-yellow-500/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-276"></div>
                <div className="bg-yellow-400/10 rounded-xl p-3 group-hover:bg-yellow-400/20 transition-colors relative z-10 shadow-[0_0_15px_rgba(234,179,8,0.1)] group-hover:shadow-[0_0_20px_rgba(234,179,8,0.3)]" data-id="element-277">
                  <item.icon className="h-6 w-6 text-yellow-400" data-id="element-278" />
                </div>
                <div data-id="element-279">
                  <h3 className="text-xl font-bold text-white mb-1 group-hover:text-yellow-400 transition-colors" data-id="element-280">
                    {item.title}
                  </h3>
                  <p className="text-slate-400 text-sm leading-relaxed" data-id="element-281">
                    {item.desc}
                  </p>
                </div>
              </div>)}
          </div>

          <div className="mt-12 bg-gradient-to-r from-yellow-400 to-yellow-600 rounded-2xl p-1 shadow-2xl" data-id="element-282">
            <div className="bg-slate-900 rounded-[14px] py-6 px-8 flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-283">
              <div className="flex items-center gap-4" data-id="element-284">
                <div className="bg-green-500/20 rounded-full p-3" data-id="element-285">
                  <CheckIcon className="h-8 w-8 text-green-500" data-id="element-286" />
                </div>
                <div data-id="element-287">
                  <p className="text-white font-black text-xl md:text-2xl uppercase italic" data-id="element-288">
                    ¡Acceso inmediato garantizado!
                  </p>
                  <p className="text-slate-400 text-sm" data-id="element-289">
                    Recibís todo el material en tu email apenas confirmás el
                    pago.
                  </p>
                </div>
              </div>
              <div className="flex -space-x-3" data-id="element-290">
                {[1, 2, 3, 4, 5].map(n => <div key={n} className="h-10 w-10 rounded-full border-2 border-slate-900 bg-slate-700 flex items-center justify-center text-[10px] font-bold" data-id="element-291">
                    {n}⭐
                  </div>)}
                <div className="h-10 px-4 rounded-full border-2 border-slate-900 bg-yellow-500 text-black flex items-center justify-center text-xs font-black" data-id="element-292">
                  +583 COLEGAS
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Product Preview Carousel */}
      <ProductPreviewCarousel data-id="element-293" />

      {/* Authority / Trust Section — who we are */}
      <section className="w-full bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-slate-800 via-slate-900 to-black text-white py-16 px-4 border-t border-slate-800 relative overflow-hidden" data-id="element-294">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-72 bg-yellow-500/8 rounded-full blur-[100px] pointer-events-none" data-id="element-295"></div>
        <div className="absolute inset-0 opacity-[0.02] pointer-events-none" style={{
        backgroundImage: 'linear-gradient(rgba(255,255,255,1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,1) 1px, transparent 1px)',
        backgroundSize: '64px 64px'
      }} data-id="element-296"></div>

        <div className="max-w-6xl mx-auto relative z-10" data-id="element-297">
          <div className="text-center mb-12" data-id="element-298">
            <div className="inline-flex items-center gap-2 bg-yellow-500/10 border border-yellow-500/30 text-yellow-400 font-bold text-sm px-6 py-2 rounded-full mb-6 uppercase tracking-widest shadow-[0_0_20px_rgba(234,179,8,0.15)]" data-id="element-299">
              <AwardIcon className="h-4 w-4" data-id="element-300" /> Trayectoria y confianza
            </div>
            <h2 className="text-3xl md:text-5xl font-black uppercase text-transparent bg-clip-text bg-gradient-to-r from-yellow-200 via-yellow-400 to-yellow-200 tracking-tight drop-shadow-[0_0_15px_rgba(234,179,8,0.2)]" data-id="element-301">
              Hecho por la comunidad de abogados más grande de Argentina
            </h2>
            <p className="text-lg md:text-xl text-slate-300 mt-4 max-w-3xl mx-auto font-light" data-id="element-302">
              Somos la comunidad creadora de soluciones para abogados y
              estudiantes de abogacía{' '}
              <span className="text-white font-semibold" data-id="element-303">
                más importante del país
              </span>
              . Este MegaPack no lo armó cualquiera: lo construimos entre
              profesionales que viven lo mismo que vos.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-10 items-center" data-id="element-304">
            {/* Instagram proof screenshot */}
            <div className="flex justify-center" data-id="element-305">
              <div className="relative group max-w-[300px]" data-id="element-306">
                <div className="absolute inset-0 bg-yellow-500/15 rounded-[2rem] blur-2xl group-hover:bg-yellow-500/25 transition-all duration-500" data-id="element-307"></div>
                <div className="relative bg-slate-900/80 backdrop-blur-xl rounded-[2rem] border border-yellow-500/30 p-2.5 shadow-[0_0_40px_rgba(234,179,8,0.15)] overflow-hidden" data-id="element-308">
                  <img src="https://cdn.magicpatterns.com/uploads/izoafXB3EzoUwuxyggz4Dw/image.png" alt="Perfil verificado de la comunidad Estudiantes de Abogacía Argentina con 33.1 mil seguidores" className="w-full h-auto rounded-[1.5rem]" data-id="element-309" />
                </div>
                <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 bg-blue-500 text-white text-xs font-black px-4 py-1.5 rounded-full shadow-lg whitespace-nowrap border border-blue-300/40" data-id="element-310">
                  ✓ Cuenta verificada
                </div>
              </div>
            </div>

            {/* Stats + scarcity */}
            <div className="space-y-6" data-id="element-311">
              <div className="grid grid-cols-2 gap-4" data-id="element-312">
                <div className="bg-slate-800/50 border border-slate-700/50 rounded-2xl p-6 text-center" data-id="element-313">
                  <p className="md:text-5xl font-black text-transparent bg-clip-text bg-gradient-to-br from-yellow-200 to-yellow-500 text-[30px]" data-id="element-314">
                    +33.100
                  </p>
                  <p className="text-sm text-slate-400 font-medium mt-1" data-id="element-315">
                    profesionales de todo Argentina
                  </p>
                </div>
                <div className="bg-slate-800/50 border border-green-500/30 rounded-2xl p-6 text-center shadow-[0_0_20px_rgba(34,197,94,0.1)]" data-id="element-316">
                  <p className="text-4xl md:text-5xl font-black text-transparent bg-clip-text bg-gradient-to-br from-green-300 to-green-500" data-id="element-317">
                    583
                  </p>
                  <p className="text-sm text-slate-400 font-medium mt-1" data-id="element-318">
                    con acceso al grupo privado
                  </p>
                </div>
              </div>

              <div className="bg-green-500/10 border border-green-500/30 rounded-2xl p-6 shadow-[0_0_20px_rgba(34,197,94,0.1)]" data-id="element-319">
                <p className="text-base md:text-lg text-green-200 font-bold leading-relaxed" data-id="element-320">
                  🔒 De más de <span className="text-white" data-id="element-321">33.100</span>{' '}
                  miembros, solo <span className="text-green-300" data-id="element-322">583</span>{' '}
                  tienen el privilegio de interactuar a diario en el grupo
                  privado de WhatsApp — y hoy podés ser uno de ellos al realizar
                  tu compra.
                </p>
              </div>

              {/* Trust pillars */}
              <div className="grid grid-cols-3 gap-3" data-id="element-323">
                {[{
                icon: AwardIcon,
                label: 'Trayectoria'
              }, {
                icon: ShieldIcon,
                label: 'Seguridad'
              }, {
                icon: CheckIcon,
                label: 'Transparencia'
              }].map((p, i) => <div key={i} className="bg-slate-800/40 border border-slate-700/50 rounded-xl p-4 flex flex-col items-center gap-2 text-center" data-id="element-324">
                    <p.icon className="h-6 w-6 text-yellow-400" data-id="element-325" />
                    <span className="text-xs md:text-sm font-bold text-slate-200" data-id="element-326">
                      {p.label}
                    </span>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Community Section — desire + urgency before the offer */}
      <section className="w-full bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-slate-900 via-slate-950 to-black text-white py-16 px-4 border-t border-slate-800 relative overflow-hidden" data-id="element-327">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-green-500/10 rounded-full blur-[100px] pointer-events-none" data-id="element-328"></div>
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-yellow-500/8 rounded-full blur-[100px] pointer-events-none" data-id="element-329"></div>

        <div className="max-w-6xl mx-auto relative z-10" data-id="element-330">
          <div className="text-center mb-12" data-id="element-331">
            <div className="inline-flex items-center gap-2 bg-green-500/10 border border-green-500/30 text-green-400 font-bold text-sm px-6 py-2 rounded-full mb-6 uppercase tracking-widest shadow-[0_0_20px_rgba(34,197,94,0.15)]" data-id="element-332">
              <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" data-id="element-333"></span>
              Comunidad activa
            </div>
            <h2 className="text-3xl md:text-5xl font-black uppercase text-transparent bg-clip-text bg-gradient-to-r from-yellow-200 via-yellow-400 to-yellow-200 tracking-tight drop-shadow-[0_0_15px_rgba(234,179,8,0.2)]" data-id="element-334">
              La red de abogados más importante de Argentina
            </h2>
            <p className="text-lg md:text-xl text-slate-300 mt-4 max-w-3xl mx-auto font-light" data-id="element-335">
              No comprás solo un material. Entrás a una red de colegas de todas
              las provincias que te respaldan{' '}
              <span className="text-white font-semibold" data-id="element-336">todos los días</span>.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-10 items-center" data-id="element-337">
            {/* Community card image */}
            <div className="relative group" data-id="element-338">
              <div className="absolute inset-0 bg-green-500/15 rounded-3xl blur-2xl group-hover:bg-green-500/25 transition-all duration-500" data-id="element-339"></div>
              <div className="relative bg-slate-900/80 backdrop-blur-xl rounded-3xl border border-green-500/30 p-4 shadow-[0_0_40px_rgba(34,197,94,0.15)] overflow-hidden" data-id="element-340">
                <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-green-400 via-green-500 to-green-400" data-id="element-341"></div>
                <img src="https://cdn.magicpatterns.com/uploads/qsEbeT9uh2z6tLzZSsqeYT/image.png" alt="Grupo Noveles abogados y estudiantes de Argentina — 583 miembros" className="w-full h-auto rounded-2xl" data-id="element-342" />
                <div className="mt-4 flex items-center justify-center gap-3 pb-2" data-id="element-343">
                  <div className="flex -space-x-2" data-id="element-344">
                    {[1, 2, 3, 4].map(n => <div key={n} className="h-8 w-8 rounded-full border-2 border-slate-900 bg-slate-700 flex items-center justify-center text-[9px] font-bold" data-id="element-345">
                        {n}⭐
                      </div>)}
                  </div>
                  <p className="text-sm text-slate-300 font-semibold" data-id="element-346">
                    <span className="text-green-400 font-black" data-id="element-347">+583</span>{' '}
                    colegas ya adentro
                  </p>
                </div>
              </div>
            </div>

            {/* Benefits */}
            <div className="space-y-4" data-id="element-348">
              {[{
              icon: ZapIcon,
              title: 'Soporte en vivo todos los días',
              desc: 'Tirás tu duda y destrabás el caso en minutos, no en semanas.'
            }, {
              icon: UsersIcon,
              title: 'Red de contactos en todas las provincias',
              desc: 'Colegas de toda Argentina listos para ayudarte con averiguaciones y trámites locales.'
            }, {
              icon: ShieldIcon,
              title: 'Soluciones casi inmediatas',
              desc: 'Ante una inseguridad o situación complicada en un caso, nunca estás solo.'
            }, {
              icon: AwardIcon,
              title: 'Networking que vale oro',
              desc: 'Contactos, derivaciones y oportunidades reales que esta red genera todos los días.'
            }].map((item, i) => <div key={i} className="flex items-start gap-4 bg-slate-800/40 backdrop-blur-md border border-slate-700/50 rounded-2xl p-5 hover:border-green-500/40 hover:bg-slate-800/60 transition-all duration-300" data-id="element-349">
                  <div className="bg-green-500/15 rounded-xl p-3 flex-shrink-0 shadow-[0_0_15px_rgba(34,197,94,0.1)]" data-id="element-350">
                    <item.icon className="h-6 w-6 text-green-400" data-id="element-351" />
                  </div>
                  <div data-id="element-352">
                    <h3 className="text-lg font-bold text-white mb-1" data-id="element-353">
                      {item.title}
                    </h3>
                    <p className="text-sm text-slate-400 leading-relaxed" data-id="element-354">
                      {item.desc}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>

          {/* Urgency + value line */}
          <div className="mt-12 bg-red-500/10 border border-red-500/30 rounded-2xl p-6 text-center max-w-3xl mx-auto" data-id="element-355">
            <p className="text-lg md:text-xl font-bold text-red-300" data-id="element-356">
              ⚠️ El acceso a la comunidad está incluido solo dentro de la oferta
              de hoy. Esta red de contactos ya de por sí es invaluable — y
              merecés formar parte de ella.
            </p>
          </div>

          <div className="flex justify-center mt-8" data-id="element-357">
            <a href="#compra" onClick={scrollToOffer} className="inline-block bg-gradient-to-r from-green-500 to-green-600 text-white font-black text-lg md:text-2xl px-12 py-6 rounded-xl shadow-[0_0_30px_rgba(34,197,94,0.3)] hover:shadow-[0_0_50px_rgba(34,197,94,0.5)] transform hover:scale-105 transition-all duration-300 uppercase text-center border-2 border-green-400" data-id="element-358">
              QUIERO ENTRAR A LA COMUNIDAD
            </a>
          </div>
        </div>
      </section>

      {/* Urgency Module — right before the offer */}
      <UrgencyModule data-id="element-359" />

      {/* Pricing Section — CHECKOUT DIRECTO */}
      <section id="compra" className="w-full bg-[#f8fafc] py-14 px-4 relative overflow-hidden" data-id="element-360">
        <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-slate-300 to-transparent" data-id="element-361"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-4xl h-full bg-yellow-500/5 rounded-full blur-[120px] pointer-events-none" data-id="element-362"></div>

        <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-363">
          {/* Urgency badge */}
          <div className="inline-flex items-center gap-2 bg-red-600 text-white font-black text-sm px-6 py-2.5 rounded-full mb-8 uppercase tracking-widest shadow-[0_0_20px_rgba(220,38,38,0.3)] animate-pulse" data-id="element-364">
            🔥 Oferta por tiempo limitado
          </div>

          <h2 className="text-4xl md:text-6xl font-black text-slate-900 mb-4 uppercase text-center tracking-tight" data-id="element-365">
            Invertí en tu carrera hoy
          </h2>
          <p className="text-xl md:text-2xl text-slate-600 mb-12 text-center font-light" data-id="element-366">
            Todo lo que necesitás para ejercer con{' '}
            <span className="font-bold text-slate-900" data-id="element-367">seguridad</span> desde el
            día 1
          </p>

          <div className="bg-white rounded-[2.5rem] shadow-[0_20px_60px_-15px_rgba(0,0,0,0.1),0_0_40px_rgba(234,179,8,0.15)] overflow-hidden border border-slate-100 mb-10 relative" data-id="element-368">
            <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-yellow-400 via-yellow-500 to-yellow-400" data-id="element-369"></div>
            <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-yellow-50/50 via-white to-white opacity-100 pointer-events-none" data-id="element-370"></div>

            {/* Top ribbon */}
            <div className="bg-slate-900 py-4 px-6 relative z-10 shadow-md" data-id="element-371">
              <p className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-200 via-yellow-400 to-yellow-200 font-black text-lg md:text-xl uppercase text-center tracking-widest" data-id="element-372">
                ⚖️ Oferta especial — Guía + 6 Bonus incluidos ⚖️
              </p>
            </div>

            <div className="p-8 md:p-12 relative z-10" data-id="element-373">
              {/* Price comparison */}
              <div className="mb-8" data-id="element-374">
                <p className="text-xl md:text-2xl line-through mb-2 text-center font-medium text-[#E10A14]" data-id="element-375">
                  Precio regular: ARS 87.500
                </p>
                <div className="flex items-center justify-center gap-3 mb-2" data-id="element-376">
                  <span className="text-2xl md:text-3xl font-black text-slate-800 uppercase tracking-tight" data-id="element-377">
                    Hoy solo:
                  </span>
                </div>
                <p className="md:text-8xl font-black text-transparent bg-clip-text bg-gradient-to-br from-green-500 to-green-700 text-center drop-shadow-sm text-[48px]" data-id="element-378">
                  ARS 34.999
                </p>
              </div>

              {/* Savings badge */}
              <div className="flex justify-center mb-8" data-id="element-379">
                <div className="inline-flex items-center gap-2 bg-green-50 border border-green-200 text-green-700 font-black text-xl md:text-2xl px-8 py-3 rounded-2xl shadow-sm" data-id="element-380">
                  Ahorrás: ARS 52.500
                </div>
              </div>

              {/* Benefits grid */}
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8" data-id="element-381">
                <div className="bg-slate-50 rounded-xl p-4 text-center border border-slate-200" data-id="element-382">
                  <ZapIcon className="h-7 w-7 text-yellow-500 mx-auto mb-2" data-id="element-383" />
                  <p className="text-sm font-bold text-slate-800" data-id="element-384">
                    Acceso inmediato
                  </p>
                </div>
                <div className="bg-slate-50 rounded-xl p-4 text-center border border-slate-200" data-id="element-385">
                  <DownloadIcon className="h-7 w-7 text-slate-700 mx-auto mb-2" data-id="element-386" />
                  <p className="text-sm font-bold text-slate-800" data-id="element-387">
                    Descarga digital
                  </p>
                </div>
                <div className="bg-slate-50 rounded-xl p-4 text-center border border-slate-200" data-id="element-388">
                  <ClockIcon className="h-7 w-7 text-slate-700 mx-auto mb-2" data-id="element-389" />
                  <p className="text-sm font-bold text-slate-800" data-id="element-390">
                    Acceso de por vida
                  </p>
                </div>
                <div className="bg-slate-50 rounded-xl p-4 text-center border border-slate-200" data-id="element-391">
                  <ShieldIcon className="h-7 w-7 text-green-600 mx-auto mb-2" data-id="element-392" />
                  <p className="text-sm font-bold text-slate-800" data-id="element-393">
                    Garantía 7 días
                  </p>
                </div>
              </div>

              {/* WhatsApp community callout */}
              <div className="bg-green-50 border border-green-300 rounded-xl p-4 mb-8 flex items-center justify-center gap-3" data-id="element-394">
                <UsersIcon className="h-6 w-6 text-green-700 flex-shrink-0" data-id="element-395" />
                <p className="text-sm md:text-base text-green-900 font-bold text-center" data-id="element-396">
                  La comunidad de WhatsApp más grande de abogados y estudiantes
                  de abogacía te está esperando 🇦🇷
                </p>
              </div>

              {/* Installments — small standout pill right above CTA */}
              <div className="flex justify-center mb-4" data-id="element-397">
                <div className="inline-flex items-center gap-1.5 bg-green-50 border border-green-300 rounded-full py-1.5 px-4 shadow-[0_0_15px_rgba(34,197,94,0.15)]" data-id="element-398">
                  <p className="text-xs md:text-sm font-bold text-slate-700 text-center" data-id="element-399">
                    💳 Pagá en hasta{' '}
                    <span className="text-green-600 font-black" data-id="element-400">3 cuotas</span>{' '}
                    — Acceso inmediato
                  </p>
                </div>
              </div>

              {/* CTA Button */}
              <div className="flex justify-center mb-4 relative z-10" data-id="element-401">
                <a href="https://megapack-novelesabogados.impultienda.ar/" className="inline-block bg-gradient-to-r from-green-500 to-green-600 text-white font-black text-xl md:text-3xl px-12 py-6 rounded-xl shadow-[0_0_30px_rgba(34,197,94,0.4)] hover:shadow-[0_0_50px_rgba(34,197,94,0.6)] transform hover:scale-105 transition-all duration-300 animate-pulse-slow uppercase text-center border-2 border-green-400" data-id="element-402">
                  QUIERO ACCEDER AHORA + 7 DIAS DE GARANTIA ⭐
                </a>
              </div>

              {/* Payment & security badges */}
              <div className="flex justify-center mb-4" data-id="element-403">
                <img src="https://cdn.magicpatterns.com/uploads/na8BuWPBQNjFajZ2AV1MpB/pasted-image.jpg" alt="Mercado Pago, VISA, Mastercard — Compra 100% segura, SSL certificado" className="w-full max-w-xs h-auto rounded-2xl border border-slate-200 shadow-sm" data-id="element-404" />
              </div>

              <p className="text-base font-bold text-slate-700 text-center" data-id="element-405">
                ✔ Válido para toda Argentina 🇦🇷
              </p>
            </div>
          </div>

          {/* Guarantee */}
          <div className="max-w-2xl mx-auto bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-slate-900 via-slate-950 to-black rounded-3xl px-8 py-12 md:px-12 shadow-[0_20px_60px_-15px_rgba(0,0,0,0.4)] border border-slate-800 relative overflow-hidden" data-id="element-406">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-72 h-40 bg-green-500/15 rounded-full blur-3xl pointer-events-none" data-id="element-407"></div>

            {/* Shield */}
            <div className="flex justify-center mb-6 relative z-10" data-id="element-408">
              <div className="relative" data-id="element-409">
                <div className="absolute inset-0 bg-green-500/30 rounded-full blur-2xl scale-150" data-id="element-410"></div>
                <div className="relative w-24 h-24 rounded-2xl bg-gradient-to-br from-green-400 to-green-600 flex items-center justify-center shadow-[0_0_30px_rgba(34,197,94,0.5)] border border-green-300/40" data-id="element-411">
                  <ShieldIcon className="h-12 w-12 text-white drop-shadow-lg" data-id="element-412" />
                </div>
              </div>
            </div>

            {/* Heading */}
            <h3 className="text-2xl md:text-4xl font-black text-transparent bg-clip-text bg-gradient-to-r from-yellow-200 via-yellow-400 to-yellow-200 uppercase text-center tracking-tight mb-8 drop-shadow-[0_0_15px_rgba(234,179,8,0.2)] relative z-10" data-id="element-413">
              Garantía 7 días — Sin preguntas
            </h3>

            {/* Inner glowing card */}
            <div className="rounded-2xl border border-green-500/40 bg-slate-900/60 backdrop-blur-md px-6 py-8 md:px-10 text-center shadow-[0_0_30px_rgba(34,197,94,0.12)] relative z-10" data-id="element-414">
              <p className="text-base md:text-lg text-slate-300 mb-4 font-medium" data-id="element-415">
                Abrís el material. Lo usás en tus casos reales.
              </p>
              <p className="text-base md:text-lg text-slate-300 mb-6 font-medium" data-id="element-416">
                Si en 7 días no es exactamente lo que esperabas:
              </p>
              <p className="text-3xl md:text-4xl font-black text-transparent bg-clip-text bg-gradient-to-r from-green-300 via-green-400 to-green-300 mb-4 drop-shadow-[0_0_15px_rgba(34,197,94,0.3)]" data-id="element-417">
                devolución del 100%
              </p>
              <p className="text-lg md:text-xl font-bold text-white" data-id="element-418">
                sin formularios, sin drama, sin explicaciones.
              </p>
            </div>

            {/* Footer line */}
            <p className="text-sm text-slate-500 text-center mt-8 font-medium tracking-wide relative z-10" data-id="element-419">
              Tasa de devoluciones:{' '}
              <span className="text-green-400 font-bold" data-id="element-420">menos del 1%</span>.
            </p>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="w-full bg-white py-14 px-4 relative overflow-hidden" data-id="element-421">
        <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-slate-200 to-transparent" data-id="element-422"></div>
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-64 bg-amber-400/5 rounded-full blur-3xl pointer-events-none" data-id="element-423"></div>
        <div className="max-w-6xl mx-auto relative z-10" data-id="element-424">
          <div className="text-center mb-16" data-id="element-425">
            <span className="inline-block bg-yellow-100 text-yellow-800 font-bold px-4 py-1.5 rounded-full text-sm uppercase tracking-widest mb-4" data-id="element-426">
              Casos de éxito
            </span>
            <h2 className="text-3xl md:text-5xl font-black text-slate-900 text-center uppercase tracking-tight" data-id="element-427">
              Lo que dicen otros noveles abogados
            </h2>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-428">
            {[{
            name: 'Valentina Rodríguez',
            age: 25,
            city: 'Buenos Aires',
            text: '"Me ordenó la cabeza completamente. Dejé de tardar horas en cosas básicas y ahora presento escritos con confianza."'
          }, {
            name: 'Matías González',
            age: 27,
            city: 'Córdoba',
            text: '"El paso a paso del PJN me ahorró errores reales. Lo recomiendo a cualquier novel que esté empezando."'
          }, {
            name: 'Lucía Fernández',
            age: 26,
            city: 'Rosario',
            text: '"Por fin entendí cómo cobrar mis honorarios sin sentirme incómoda. Vale cada peso."'
          }, {
            name: 'Sebastián Torres',
            age: 28,
            city: 'Mendoza',
            text: '"La guía de la primera entrevista me cambió todo. Ahora salgo con próximos pasos claros siempre."'
          }, {
            name: 'Camila Martínez',
            age: 25,
            city: 'Tucumán',
            text: '"Dejé de improvisar. Tengo un sistema real para ejercer y eso me da una seguridad que antes no tenía."'
          }, {
            name: 'Joaquín Pereyra',
            age: 26,
            city: 'La Plata',
            text: '"Pensé que iba a ser otro PDF más y me sorprendió mucho. Lo del PJN sobre todo, lo apliqué la misma semana y me funcionó."'
          }, {
            name: 'Florencia Acosta',
            age: 27,
            city: 'Salta',
            text: '"Recién recibida, sin estudio donde caerme. Esta guía fue la mano que necesitaba. Hoy facturo mejor y trabajo más tranquila."'
          }, {
            name: 'Tomás Iriarte',
            age: 24,
            city: 'Bahía Blanca',
            text: '"Lo bueno es que no es teoría boba. Es lo que necesitás cuando estás en el medio del lío y no sabés qué hacer. Súper práctico."'
          }, {
            name: 'Antonella Vega',
            age: 28,
            city: 'Neuquén',
            text: '"El grupo de WhatsApp solo ya vale la inversión. Te sacás dudas al toque con colegas que están en la misma."'
          }, {
            name: 'Bruno Salinas',
            age: 26,
            city: 'Posadas',
            text: '"Lo compré medio desconfiado, pero la verdad lo recomiendo. Me ordenó todo y dejé de sentirme perdido en cada trámite."'
          }].map((t, i) => <div key={i} className="bg-white rounded-2xl shadow-[0_0_20px_rgba(0,0,0,0.05)] hover:shadow-[0_0_30px_rgba(234,179,8,0.15)] hover:-translate-y-1 transition-all duration-300 p-8 border border-slate-200" data-id="element-429">
                <div className="flex gap-1 mb-4 justify-center" data-id="element-430">
                  {[...Array(5)].map((_, j) => <StarIcon key={j} className="h-5 w-5 text-yellow-500 fill-yellow-500" data-id="element-431" />)}
                </div>
                <p className="text-slate-700 mb-4 italic text-center" data-id="element-432">
                  {t.text}
                </p>
                <div className="border-t pt-4 text-center border-slate-200" data-id="element-433">
                  <p className="font-bold text-slate-900" data-id="element-434">{t.name}</p>
                  <p className="text-sm text-slate-600" data-id="element-435">
                    {t.age} años — Abogado/a (1er año) — {t.city}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="w-full bg-gradient-to-b from-white via-slate-50 to-white py-10 px-4 relative overflow-hidden" data-id="element-436">
        <div className="max-w-4xl mx-auto relative z-10" data-id="element-437">
          <h2 className="text-3xl md:text-5xl font-black text-slate-900 mb-12 text-center uppercase" data-id="element-438">
            ❓ Preguntas frecuentes
          </h2>
          <div className="space-y-4" data-id="element-439">
            {[{
            q: '¿Esto es para estudiantes?',
            a: 'No. Está pensado solo para noveles abogados en su primer año.'
          }, {
            q: '¿Es material digital?',
            a: 'Sí. Acceso y descarga inmediata.'
          }, {
            q: '¿Sirve en cualquier provincia?',
            a: 'Sí. Es válido para toda Argentina. (Y el bono del PJN aplica a los fueros principales.)'
          }, {
            q: '¿Necesito experiencia previa?',
            a: 'No. Es paso a paso, pensado para arrancar con estructura.'
          }, {
            q: '¿Esto reemplaza asesoramiento legal?',
            a: 'No. Es material educativo y de apoyo práctico. La estrategia jurídica siempre depende del caso.'
          }, {
            q: '¿Cómo recibo el material después de pagar?',
            a: 'Apenas confirmás la compra, recibís un email con los enlaces de descarga y el acceso al grupo de WhatsApp. Es inmediato.'
          }, {
            q: '¿Qué métodos de pago puedo usar?',
            a: 'Aceptamos todas las tarjetas de crédito y débito, además de Mercado Pago. Podés pagar hasta en 3 cuotas según tu tarjeta.'
          }, {
            q: '¿Tiene actualizaciones futuras incluidas?',
            a: 'Sí. Mientras tengamos acceso de por vida, recibís las actualizaciones de modelos y normativa que vayamos sumando, sin costo extra.'
          }, {
            q: '¿Hay soporte si tengo dudas con el material?',
            a: 'Sí. Podés escribirnos por mail y además tenés el grupo de WhatsApp con +583 colegas y nuestro equipo para destrabar cualquier duda.'
          }, {
            q: '¿Cómo funciona la garantía de 7 días?',
            a: 'Tenés 7 días desde la compra para probarlo. Si no te resulta útil, nos escribís y te devolvemos el 100% del dinero sin preguntas.'
          }].map((faq, index) => <div key={index} className="bg-white rounded-2xl overflow-hidden border border-slate-200 shadow-[0_0_15px_rgba(0,0,0,0.03)] hover:shadow-[0_0_25px_rgba(234,179,8,0.15)] transition-shadow duration-300" data-id="element-440">
                <button onClick={() => setOpenFaq(openFaq === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left hover:bg-slate-100 transition-colors" data-id="element-441">
                  <span className="text-lg font-bold text-slate-900" data-id="element-442">
                    {faq.q}
                  </span>
                  <ChevronDownIcon className={`h-6 w-6 text-slate-600 transition-transform ${openFaq === index ? 'rotate-180' : ''}`} data-id="element-443" />
                </button>
                {openFaq === index && <div className="px-6 pb-6" data-id="element-444">
                    <p className="text-slate-700" data-id="element-445">{faq.a}</p>
                  </div>}
              </div>)}
          </div>
        </div>
      </section>

      {/* Cost of Inaction Section */}
      <section className="w-full bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-slate-900 via-slate-950 to-black text-white py-14 px-4 border-t border-slate-800 relative overflow-hidden" data-id="element-446">
        <div className="absolute top-1/2 left-0 w-96 h-96 bg-red-500/10 rounded-full blur-[100px] pointer-events-none" data-id="element-447"></div>
        <div className="absolute top-1/2 right-0 w-96 h-96 bg-yellow-500/5 rounded-full blur-[100px] pointer-events-none" data-id="element-448"></div>

        <div className="max-w-5xl mx-auto relative z-10" data-id="element-449">
          <div className="text-center mb-12" data-id="element-450">
            <h2 className="text-3xl md:text-5xl font-black uppercase text-transparent bg-clip-text bg-gradient-to-r from-yellow-200 via-yellow-400 to-yellow-200 tracking-tight drop-shadow-[0_0_15px_rgba(234,179,8,0.2)]" data-id="element-451">
              ⚖️ ¿Cuánto cuesta NO tenerlo?
            </h2>
            <p className="text-lg md:text-xl text-slate-300 mt-4 max-w-2xl mx-auto font-light" data-id="element-452">
              No comprarlo también tiene un precio. Y se paga en tiempo, plata y
              oportunidades perdidas.
            </p>
          </div>

          <div className="bg-slate-800/40 backdrop-blur-xl rounded-3xl border border-slate-700/50 shadow-2xl overflow-hidden" data-id="element-453">
            {/* Table header */}
            <div className="grid grid-cols-2 bg-slate-900/80 border-b border-slate-700/50" data-id="element-454">
              <div className="py-5 px-5 md:px-8 text-center border-r border-slate-700/50" data-id="element-455">
                <span className="text-sm md:text-lg font-black uppercase tracking-widest text-slate-300" data-id="element-456">
                  Sin MegaPack
                </span>
              </div>
              <div className="py-5 px-5 md:px-8 text-center" data-id="element-457">
                <span className="text-sm md:text-lg font-black uppercase tracking-widest text-red-400" data-id="element-458">
                  Costo real
                </span>
              </div>
            </div>

            {[{
            without: 'Horas perdidas buscando modelos y formatos cada semana',
            cost: 'Semanas enteras de tu primer año tiradas a la basura'
          }, {
            without: 'Escritos rebotados por un formato mal armado',
            cost: 'Demoras, retrabajo y estrés que no para nunca'
          }, {
            without: 'Honorarios calculados "a ojo"',
            cost: 'Plata que dejás sobre la mesa en cada caso'
          }, {
            without: 'Trabas al subir escritos al portal del PJN',
            cost: 'Plazos en riesgo y clientes que se enojan'
          }, {
            without: 'Primera entrevista con clientes sin estructura',
            cost: 'Clientes que no vuelven ni te recomiendan'
          }, {
            without: 'Dudas que te frenan y nadie a quién preguntarle',
            cost: 'Avanzás lento y vivís corriendo atrás de todo'
          }, {
            without: 'Improvisar cada trámite desde cero',
            cost: 'El mismo caos el año que viene'
          }].map((row, i) => <div key={i} className={`grid grid-cols-2 border-b border-slate-700/40 ${i % 2 === 0 ? 'bg-slate-800/20' : 'bg-transparent'}`} data-id="element-459">
                <div className="py-5 px-5 md:px-8 border-r border-slate-700/40 flex items-start gap-3" data-id="element-460">
                  <XIcon className="h-5 w-5 text-red-400 flex-shrink-0 mt-0.5" data-id="element-461" />
                  <span className="text-sm md:text-base text-slate-300 font-medium leading-relaxed" data-id="element-462">
                    {row.without}
                  </span>
                </div>
                <div className="py-5 px-5 md:px-8 flex items-start gap-3" data-id="element-463">
                  <span className="text-red-500 font-black flex-shrink-0 mt-0.5" data-id="element-464">
                    ↳
                  </span>
                  <span className="text-sm md:text-base text-red-300 font-semibold leading-relaxed" data-id="element-465">
                    {row.cost}
                  </span>
                </div>
              </div>)}
          </div>

          <div className="mt-10 text-center" data-id="element-466">
            <p className="inline-block bg-yellow-500/10 border border-yellow-500/30 text-yellow-300 px-8 py-4 rounded-2xl text-lg md:text-xl font-bold shadow-[0_0_20px_rgba(234,179,8,0.1)]" data-id="element-467">
              El MegaPack cuesta menos que una sola semana perdida improvisando.
            </p>
          </div>

          <div className="flex justify-center mt-8" data-id="element-468">
            <a href="#compra" onClick={scrollToOffer} className="inline-block bg-gradient-to-r from-green-500 to-green-600 text-white font-black text-lg md:text-2xl px-12 py-6 rounded-xl shadow-[0_0_30px_rgba(34,197,94,0.3)] hover:shadow-[0_0_50px_rgba(34,197,94,0.5)] transform hover:scale-105 transition-all duration-300 uppercase text-center border-2 border-green-400" data-id="element-469">
              QUIERO DEJAR DE PERDER TIEMPO
            </a>
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="w-full bg-[radial-gradient(ellipse_at_bottom,_var(--tw-gradient-stops))] from-slate-900 via-slate-950 to-black text-white py-14 px-4 border-t border-slate-800 relative overflow-hidden" data-id="element-470">
        <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-96 bg-yellow-500/10 rounded-full blur-[100px] pointer-events-none" data-id="element-471"></div>
        <div className="absolute inset-0 opacity-[0.03]" style={{
        backgroundImage: 'linear-gradient(rgba(255,255,255,1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,1) 1px, transparent 1px)',
        backgroundSize: '64px 64px'
      }} data-id="element-472"></div>

        <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-473">
          <h2 className="text-4xl md:text-6xl font-black mb-8 uppercase text-center text-transparent bg-clip-text bg-gradient-to-r from-yellow-200 via-yellow-400 to-yellow-200 tracking-tight drop-shadow-[0_0_15px_rgba(234,179,8,0.2)]" data-id="element-474">
            Tu primer año no tiene por qué ser "modo caos".
          </h2>
          <div className="bg-slate-800/50 backdrop-blur-md border border-slate-700/50 rounded-3xl p-8 md:p-12 mb-12 shadow-2xl" data-id="element-475">
            <p className="text-xl md:text-3xl mb-4 text-center text-slate-300 font-light" data-id="element-476">
              No necesitás más PDFs sueltos.
            </p>
            <p className="text-xl md:text-3xl text-center text-white font-medium" data-id="element-477">
              Necesitás un sistema para ejercer con{' '}
              <span className="text-yellow-400 font-bold" data-id="element-478">
                seguridad y velocidad
              </span>{' '}
              desde ya.
            </p>
          </div>
          {/* ÚLTIMO BOTÓN → CHECKOUT DIRECTO */}
          <a href="https://megapack-novelesabogados.impultienda.ar/" className="inline-block bg-gradient-to-r from-green-500 to-green-600 text-white font-black text-2xl md:text-4xl px-16 py-8 rounded-2xl shadow-[0_0_40px_rgba(34,197,94,0.4)] hover:shadow-[0_0_60px_rgba(34,197,94,0.6)] transform hover:scale-105 transition-all duration-300 animate-pulse-slow uppercase text-center border-2 border-green-400" data-id="element-479">
            QUIERO MI MEGAPACK
          </a>
        </div>
      </section>
    </div>;
}